<template>
  <div class="justify-content-center stack-item border shadow p-2 rounded transition-card">
    <h6 class="text-center">
      {{ object.title }}
    </h6>

    <div
      class="lh-lg fw-normal text-dark"
      v-html="object.description"
    ></div>
  </div>
</template>

<script>
export default {
  props: ['object']

  
}
</script>

<style scoped>
.stack-item {
  background: white;
   color: darkolivegreen;
}

.transition-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /*  //border-left: 5px solid #198754;Bootstrap green */
}

.transition-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  background-color:darkolivegreen;; /* #f9fdfb;  light green tint on hover */
  color: white; /* #f9fdfb;  light green tint on hover */
  cursor: default;
}
</style>